import { i as e } from "./dist-By11B3Nf.js";
import { a as t, n } from "./dist-7tgynhKG.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-collection@1.1.12_@types+react-dom@19.2.3_@types+react@19.2.17__@types+_2a38227d192288d79faf3ff10783fd56/node_modules/@radix-ui/react-collection/dist/index.mjs
function a(a) {
	let o = a + "CollectionProvider", [s, c] = e(o), [l, u] = s(o, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), d = (e) => {
		let { scope: t, children: n } = e, a = r.useRef(null), o = r.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ i(l, {
			scope: t,
			itemMap: o,
			collectionRef: a,
			children: n
		});
	};
	d.displayName = o;
	let f = a + "CollectionSlot", p = n(f), m = r.forwardRef((e, n) => {
		let { scope: r, children: a } = e, o = t(n, u(f, r).collectionRef);
		return /* @__PURE__ */ i(p, {
			ref: o,
			children: a
		});
	});
	m.displayName = f;
	let h = a + "CollectionItemSlot", g = "data-radix-collection-item", _ = n(h), v = r.forwardRef((e, n) => {
		let { scope: a, children: o, ...s } = e, c = r.useRef(null), l = t(n, c), d = u(h, a);
		return r.useEffect(() => (d.itemMap.set(c, {
			ref: c,
			...s
		}), () => void d.itemMap.delete(c))), /* @__PURE__ */ i(_, {
			[g]: "",
			ref: l,
			children: o
		});
	});
	v.displayName = h;
	function y(e) {
		let t = u(a + "CollectionConsumer", e);
		return r.useCallback(() => {
			let e = t.collectionRef.current;
			if (!e) return [];
			let n = Array.from(e.querySelectorAll(`[${g}]`));
			return Array.from(t.itemMap.values()).sort((e, t) => n.indexOf(e.ref.current) - n.indexOf(t.ref.current));
		}, [t.collectionRef, t.itemMap]);
	}
	return [
		{
			Provider: d,
			Slot: m,
			ItemSlot: v
		},
		y,
		c
	];
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-direction@1.1.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-direction/dist/index.mjs
var o = r.createContext(void 0);
function s(e) {
	let t = r.useContext(o);
	return e || t || "ltr";
}
//#endregion
export { a as n, s as t };

//# sourceMappingURL=dist-BCghvxHR.js.map